import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { GenericDocLineOpenQueueContainerModel } from "../../../../../../models";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class GenericDocLineOpenQueueService extends BaseApiTemplateService<GenericDocLineOpenQueueContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc/line-open-queues";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc/line-open-queues";
    this.httpClient = http;
  }

  approveLineItem(
    guid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url +
        this.endpoint_path +
        "/backoffice-ep/approve/" +
        guid;
    }
    const body = {};
    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl,
      body,
      this.getHttpHeader(visa)
    );
  }

  approveLineItems(lineGuids: string[], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl =
        visa.api_domain_url +
        this.endpoint_path +
        "/backoffice-ep/batch-approve";
    }

    const body = {
      guids: lineGuids,
    };
    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl,
      body,
      this.getHttpHeader(visa)
    );
  }

  deletePermenetly(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/delete-open-queues/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  deleteByGendocHdrGuid(hdrGuid: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/permanent/hdr/" + hdrGuid;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

  deleteOpenQueueCreateCloseQueue(guid: string, visa: ApiVisa){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + "/" +Core2Config.BACKOFFICE_EP_SUFFIX + "/create-closed-queue";
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );

  }
}
